<template>
  <b-row class="rules">
    <!-- REMOVER -->
    <button
      v-if="order > 0"
      class="rules--remove-btn"
      @click="$emit('delete', order)"
    >
      <Icon icon="x-icon" />
    </button>

    <!-- DIAS DA SEMANA -->
    <b-col
      :class="{
        'col__size-full': formMultiline,
        col__nopadd: formMultiline,
        'col-12': formMultiline
      }"
      class="col__size"
    >
      <FormSelect
        v-model="value.selectedWeekDays"
        :options="weekDaysOptions"
        :class="{
          col__size: formMultiline,
          col__gutters: formMultiline,
          col__nomargin: formMultiline
        }"
        :showAllOptionsSelectedText="weekDaysOptions.length === 7"
        label="Dias da semana"
        multiple
        class="lb-form-field"
      >
        <template v-if="weekDaysOptions.length === 0">
          <p class="select__warning">
            Os dias da semana <strong>não</strong> podem ser repetidos entre as
            regras de um mesmo quarto.
          </p>
        </template>
      </FormSelect>
    </b-col>

    <!-- DESCONTO -->
    <b-col v-if="typeUpdate == 2" class="col__size">
      <PmwFormInput
        v-model="value[`desconto`]"
        :hasMask="true"
        :name="`desconto`"
        :label="`Desconto`"
        :sufix="'%'"
        mask="##"
        placeholder="0"
        class="pax-values--currency lb-form-field"
      />
    </b-col>
    <template v-if="typeUpdate == 1">
      <!-- PAX -->
      <b-col
        v-for="(pax, i) in adults"
        :key="`hotel-pax-${roomCode}-${pax}`"
        class="col__size"
      >
        <PmwFormCurrencyInput
          v-model="value[`pax${i + 1}`]"
          :options="{ currency: getCurrency }"
          :name="`pax${i + 1}`"
          :label="`${pax} Pax`"
          :suffix="getCurrency"
          placeholder="0,00"
          class="pax-values--currency lb-form-field"
        />
      </b-col>

      <!-- CRIANÇAS -->
      <b-col
        v-for="(child, i) in children"
        :key="`hotel-criancas-${roomCode}-${child}`"
        class="col__size"
      >
        <PmwFormCurrencyInput
          v-model="value[`criancas${i + 1}`]"
          :options="{ currency: getCurrency }"
          :name="`criancas${i + 1}`"
          :label="`${$options.filters.pluralizer(child, 'Criança | Crianças')}`"
          :suffix="getCurrency"
          placeholder="0,00"
          class="pax-values--currency lb-form-field"
        />
      </b-col>
    </template>
  </b-row>
</template>

<script>
import { mapGetters } from 'vuex'
import FormSelect from '@/components/_base/elements/FormSelect'
import PmwFormCurrencyInput from '@solucoes/components-lib-tmp/src/components/patterns/PmwFormCurrencyInput'
import PmwFormInput from '@solucoes/components-lib-tmp/src/components/patterns/PmwFormInput'

export default {
  name: 'RoomCardRule',
  components: {
    FormSelect,
    PmwFormInput,
    PmwFormCurrencyInput
  },
  props: {
    /**
     * Código do quarto
     */
    roomCode: {
      type: [Number, String],
      required: true
    },
    /**
     * Tipo de atualização
     */
    typeUpdate: {
      type: Number,
      default: 1
    },
    /**
     * Dias da semana disponíveis
     */
    weekDaysOptions: {
      type: Array,
      default: () => []
    },
    /**
     * Quantidade de adultos
     */
    adults: {
      type: [Number, String],
      default: 1
    },
    /**
     * Quantidade de crianças
     */
    children: {
      type: [Number, String],
      default: 0
    },
    /**
     * Objeto com as regras selecionadas atualmente
     */
    value: {
      type: Object,
      default: () => []
    },
    /**
     * Ordem em que se encontra na listagem
     */
    order: {
      type: Number,
      default: 0
    }
  },
  computed: {
    /**
     * Verifica se a quantidade de campos do form gerará uma nova linha de campos
     * @return {Boolean} true: se tiver mais de 1 linha
     */
    formMultiline() {
      return +this.adults + this.children > 4
    },
    ...mapGetters('hotel', ['getCurrency'])
  },
  watch: {
    /** Escuta mudanças no dia da semana selecionado */
    typeUpdate() {
      /** Zerar o desconto */
      this.value['desconto'] = null
      /** Zerar os valores pax */
      for (let i = 1; i <= this.adults; i++) {
        this.value['pax' + i] = null
      }
      for (let i = 1; i <= this.children; i++) {
        this.value['criancas' + i] = null
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.col {
  &__size {
    max-width: calc(100% / 5);
    min-width: calc(100% / 5);
    margin-bottom: 35px;

    &-full {
      max-width: 100%;
      width: 100%;
    }
  }

  &__gutters {
    padding-left: 10px;
    padding-right: 10px;
  }

  &__nopadd {
    padding: 0;
  }

  &__nomargin {
    margin: 0;
  }
}

.rules {
  position: relative;

  &--remove-btn {
    @include reset-button();
    position: absolute;
    top: 12px;
    right: 12px;

    .icon {
      width: 12px;
      height: 12px;
      color: $gray-dark;
    }
  }
}

.select {
  &__warning {
    padding: 0 15px;
    line-height: 16px;
    font-size: font-size('size-x-small');
    color: $primary;
  }
}

.pax-values {
  bottom: 10px;

  &--currency {
    ::v-deep {
      .pmw-form-field--label {
        font-weight: font-weight(weight-medium);
      }

      .pmw-input {
        background-color: $pmw-white;
      }

      .pmw-form-field--label {
        line-height: font-size('size-large');
        margin-bottom: 0px;
      }

      .pmw-currency-input--clear {
        margin-top: 5px;
        margin-left: 1px;
      }

      .pmw-currency-input--field {
        height: 35px;
      }

      .pmw-form-field--asterisk {
        margin-left: 6px;
      }
    }
  }
}
</style>
